import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable}  from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class EmailService {

  private users;

  constructor(private http: HttpClient) {}

  public sendEmail(name, email, subject, body) {
    return this.http.post(environment.serviceURL + '/email', {}, {
      params: new HttpParams()
                .set('name', name)
                .set('email', email)
                .set('subject', subject)
                .set('body', body)
    });
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
  };

  public createCase(caseInfo: any) {
    return this.http.post(environment.serviceURL + '/case', caseInfo);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/email.service.ts